<template>

        <div>
			<div v-if="success != ''" class="alert alert-success" role="alert"> {{success}} </div>
	        <form @submit="formSubmit" enctype="multipart/form-data">
            <input class="input" type="hidden" v-model="fdata.id" >
            <b-tabs content-class="mt-3" justified nav-item-class="" >
                <b-tab active >
                    <template v-slot:title >
                        <span class="font-weight-bold text-uppercase">Salary Computation</span>
                    </template>
					<hr>
                     <div class="row">
					 <div class="col-md-2">
					   Employee
					 </div>
					 <div class="col-md-4">
						<select id="employee_id" v-model="employee_id" name="employee_id" required class="form-control " @change="setSearch()">
						<option value="">Select Employee</option>
						 <option v-for='emply in employees'  :value='emply.employee_id'>{{ emply.name }}</option>
						</select>
					 </div>
					 
					 
					 <div class="col-md-2">
					 Fiscal Year
					 </div>
					 <div class="col-md-4">
					  <select id="fiscal_year" v-model="fiscal_year" name="fiscal_year" required class="form-control " @change="setSearch()">
						<option value="">Select Fiscal Year</option>
						 <option v-for='fyr in fiscalyears'  :value='fyr.range'>{{ fyr.range }}</option>
						</select>
					 </div>
					 </div>
					 
					 <br>
					 
					 <div class="row">
					 <div class="col-md-2">
					 Period
					 </div>
					 <div class="col-md-4">
					   <b-form-datepicker id="from_date" type="text" class="form-control" v-model="from_date" name="from_date" @input="createTag()"></b-form-datepicker> - 
					    <input id="to_date" type="text" class="form-control" v-model="to_date" name="to_date" disabled>
					 </div>
					 
					

					 
					 <div class="col-md-2">
					 Payslip Ref.
					 </div>
					 <div class="col-md-4">
					   <input id="pay_slip_ref" type="text" class="form-control" v-model="pay_slip_ref" name="pay_slip_ref" disabled> 
					 </div>
					 </div>
					 <br>
					 
					 <div class="row">
					 <div class="col-md-2">
					 Pay Slip Name.
					 </div>
					 <div class="col-md-4">
					  <input id="pay_slip_name" type="text" class="form-control" v-model="pay_slip_name" name="pay_slip_name" disabled>
					 </div>
					 
					 <div class="col-md-4">
					 <button class="btn btn-primary btn-full-width">Submit</button>
					 </div>
                     </div>
					 
					 <br>
					 
                      <hr>
					        <div class="row">
							<div class="col-md-6" style="min-width:200px"><b>Name</b></div>
							<div class="col-md-2" style="text-align:right"><b>Total</b></div>
							</div>
					 
							<div v-for="salaryhead in salaryheads" :key="salaryhead.head" class="row">
							<div class="col-md-6" style="min-width:200px">{{salaryhead.head}}</div>
							<div class="col-md-2" style="text-align:right">{{salaryhead.value}}</div>
							</div>
					 
              </b-tab>
			  
			  
			  
                <b-tab >
                    <template v-slot:title >
                        <span class="font-weight-bold text-uppercase">Other Inputs</span>
                    </template>
                    
					<hr>
					<div v-if="fdata.id != ''">
                     <div class="row">
					 
					 <div class="col-md-4">
						<select id="adhoc_field" v-model="adhoc_field" name="adhoc_field" class="form-control ">
						<option value="">Select Taxable Adhoc Inputs</option>
						 <option v-for='ahf in adhocfields'  :value='ahf.title'>{{ ahf.title }}</option>
						</select>
					 </div>
					 
					 <div class="col-md-2">
					    <input id="adhoc_field_value" type="text" class="form-control" v-model="adhoc_field_value" name="adhoc_field_value">
					 </div>
					 
					 <div class="col-md-2">
					    <button class="btn btn-primary btn-full-width" @click="saveAdhoc()" > Save </button>
					 </div>					 
					 </div>
					 
					 <hr>
					        <div class="row">
							<div class="col-md-6" style="min-width:200px"><b>Name</b></div>
							<div class="col-md-2" style="text-align:right"><b>Total</b></div>
							</div>
					        					 
							<div v-for="adhochead in adhocheadsnvalues" :key="adhochead.head" class="row">
							<div class="col-md-6" style="min-width:200px">{{adhochead.head}}</div>
							<div class="col-md-2" style="text-align:right">{{adhochead.value}}</div>
							</div>
					 
					 </div>
					 
					 <div v-if="fdata.id == ''">Please Save the Pay Slip First. Then Add Other Inputs</div>
					
                </b-tab>
                
                
                
                <b-tab >
                    <template v-slot:title >
                        <span class="font-weight-bold text-uppercase">Income Tax Detail</span>
                    </template>

                        <hr>
					        <div class="row">
							<div class="col-md-6" style="min-width:200px"><b>Name</b></div>
							<div class="col-md-2" style="text-align:right"><b>Total</b></div>
							</div>
					 
							<div v-for="taxhead in taxinfo" :key="taxhead.head" class="row">
							<div class="col-md-6" style="min-width:200px">{{taxhead.head}}</div>
							<div class="col-md-2" style="text-align:right">{{taxhead.value}}</div>
							</div>
                </b-tab>
            </b-tabs>
			</form>
        </div>
			
</template>

  <script>
	  export default {
		  mounted() {
			 // console.log('Payslip started..');   
			 // console.log(this.componentdata);  
		  },
		  props: [ 'payslip'],
				 
   
		  data() {
			  
			  return {
			      employees : [],
			      salaryheads : [], 
				  taxinfo : [],
				  fiscalyears: [],
				  adhocfields: [],
				  adhocheadsnvalues: [],
				  fdata: this.payslip,  
				  
				  success: '',
				  employee_id: '',
				  fiscal_year: '',
				  from_date: '',
				  to_date: '',
				  pay_slip_ref: '',
				  pay_slip_name: '',
				  month: '',
				  year: '',
				  adhoc_field: '',
				  adhoc_field_value: '',
				  
			  }
		  },
		  
		  methods:{
		  
			  
			  createTag: function()
			  {
			      //alert(this.from_date);
				  var fromdate=this.from_date;
				  var fromdatearray=fromdate.split("-");
				  var mnth=fromdatearray[1];
				  var month="";
				  var day="";
				  var year=fromdatearray[0];
				  if(mnth=="01")
				   month="January";

				  if(mnth=="02")
				   month="February";

				  if(mnth=="03")
				   month="March";

				  if(mnth=="04")
				   month="April";

				  if(mnth=="05")
				   month="May";

				  if(mnth=="06")
				   month="June";

				  if(mnth=="07")
				   month="July";

				  if(mnth=="08")
				   month="August";

				  if(mnth=="09")
				   month="September";

				  if(mnth=="10")
				   month="October";

				  if(mnth=="11")
				   month="November";
				   
				   if(mnth=="12")
				   month="December";
				   
				   if(mnth=="09" || mnth=="04" || mnth=="06" || mnth=="11")
				   day="30";
				   else
				   day="31";

                   this.to_date=day+" "+month+", "+year;
				   
				 var employee_name="Employee";  
				 var employeearray= this.employees;			   
					this.employees.forEach((value, index) => {
					if(this.employee_id==value.employee_id)
					employee_name=value.name;
					//console.log(value.name);
					//console.log(index);
					});
					
					this.pay_slip_name="Salary Slip of "+employee_name+" for "+month+", "+year;
					this.pay_slip_ref=this.employee_id+"-"+month+"-"+year;
					this.month=month;
					this.year=year;

				  
				  
			  },
			  
			  setSearch: function(pageflg)
			  {
			    if(this.from_date!='')
			    this.createTag();
				this.getSalaryinfo(); 
			  },
			  
			  saveAdhoc: function(pageflg)
			  {
			    //alert(this.adhoc_field) ;
				//alert(this.adhoc_field_value) ;
				
			  },
			  
			  getEmployees: function()
			  {
  
						  axios.get(this.$api_url+'/getemployees' , {
							  params: {
								  page: 1,
								  per_page: 1000000,
								  search_query: this.search,
								  search_query_by_id: '',
							  }
					  }).then(function(response){
					  this.employees = response.data.data;
  
  
				  }.bind(this));
			  },
			  
			  getFiscalyears: function()
			  {
  
						  axios.get(this.$api_url+'/getfiscalyears' , {
							  params: {
								  page: 1,
								  per_page: 10,
								  search_query: this.search,
								  search_query_by_id: '',
							  }
					  }).then(function(response){
					  this.fiscalyears = response.data;
  
  
				  }.bind(this));
			  },

  
			  
			   getSalaryinfo: function()
			  {
						  axios.get(this.$api_url+'/salary-slip/'+this.employee_id , {
							  params: {
								  fiscal_year: this.fiscal_year,
								  payslip_id: this.fdata.id,
								  search_query_by_id: '',
							  }
					  }).then(function(response){
					  //alert(response.data.salary);
					  this.salaryheads = response.data.salary;
					  this.taxinfo=response.data.tax;
					  this.adhocfields=response.data.adhocfields;
					  this.adhocheadsnvalues=response.data.adhocheadsnvalues;
  
  
				  }.bind(this));
			  },
			  

			  
			  setSalaryinfo: function()
			  {
			  //
			  },
			  
			  
			  
  
  
			  formSubmit(e) {
  
				  e.preventDefault();
  
				  let currentObj = this;
  
   
  
				  const config = {
  
					  headers: { 'content-type': 'multipart/form-data' }
  
				  }
  
   
  
				  let formData = new FormData();
  
                   //formData.append('filename', this.image); 
				   formData.append('employee_id', this.employee_id);
				   formData.append('pay_slip_ref', this.pay_slip_ref);
				   formData.append('pay_slip_name', this.pay_slip_name);
				   formData.append('month', this.month);
				   formData.append('year', this.year);
				   formData.append('from_date', this.from_date);
				   formData.append('to_date', this.to_date);
				   formData.append('fiscal_year', this.fiscal_year); 
				   if(this.adhoc_field!='')
				   formData.append('adhoc_field', this.adhoc_field);
				   if(this.adhoc_field_value!='')
				   formData.append('adhoc_field_value', this.adhoc_field_value);

  
				  axios.post(this.$api_url+'/payslip-action-vue', formData, config)
  
				  .then(function (response) {
                      currentObj.getSalaryinfo();
					  currentObj.success = response.data.success;
					  currentObj.fdata.id = response.data.payslip_id;
					  
  
				  })
  
				  .catch(function (error) {
  
					  currentObj.output = error;
  
				  });
  
			  }
  
  
		  },
		  created: function(){
		  
		     this.getEmployees();
			 this.getFiscalyears();
			 
		  if(this.fdata.id!='')
		  {
		   
		   this.fiscal_year=this.fdata.fiscal_year;
		   this.employee_id=this.fdata.employee_id;
		   this.from_date=this.fdata.from_date;
		   this.to_date=this.fdata.to_date;
		   this.pay_slip_ref=this.fdata.pay_slip_ref;
		   
		   this.setSearch();
		   this.pay_slip_name=this.fdata.pay_slip_name;
		  
		  }
			 
			 
             //this.getSalaryinfo();	
			 	
		  }
	  }
  </script>